import React from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';

import { Button } from '../ui/button';

export interface PasswordSubmissionOutcomeProps {
	variant: 'success' | 'error';
	buttonLabel: string;
	onAction: () => void;
}

// Sustituye al formulario dentro del mismo modal de contraseña una vez termina el envío
// (éxito o error): el modal existente cambia de estado, nunca se abre uno nuevo encima.
// El título y la descripción de cada resultado viven en el DialogTitle/DialogDescription
// del modal que la usa (ver p. ej. SecurityWarningModalV2), no aquí — este
// componente solo aporta el icono y la acción para continuar/reintentar. Mismo patrón
// visual que SubmissionResultModalV2 (icono en círculo de color + botón).
const PasswordSubmissionOutcome = ({
	variant,
	buttonLabel,
	onAction
}: PasswordSubmissionOutcomeProps) => {
	const isSuccess = variant === 'success';
	const Icon = isSuccess ? CheckCircle2 : AlertTriangle;

	return (
		<div className="mt-4 flex flex-col items-center gap-4">
			<div
				className={`flex items-center justify-center w-16 h-16 rounded-full ${
					isSuccess ? 'bg-green-100' : 'bg-red-100'
				}`}
			>
				<Icon className={`h-8 w-8 ${isSuccess ? 'text-arca-dark-green' : 'text-red-600'}`} />
			</div>
			<Button
				type="button"
				onClick={onAction}
				className="w-full h-11 bg-arca-dark-green hover:bg-arca-dark-green/90 text-white font-medium"
			>
				{buttonLabel}
			</Button>
		</div>
	);
};

export default PasswordSubmissionOutcome;
